/**
 * defa.views.UnitResetForm
 * A view to check if the end user is sure they'll want to reset.
 * @version 1.2.0
 */
import Form from 'scripts/poppet/form';
import template from 'templates/unitResetForm.jst.html'

const UnitResetForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	submit: function () {
		this.model.saveReset();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UnitResetForm;